import React, {useState, useEffect} from 'react';
import {Link as RouterLink} from 'react-router-dom';
import Link from '@mui/material/Link';
import {Container, Grid} from '@mui/material'
import {EmailContentService} from '../shared/service';
import CustomDataGrid from '../../../customUtil/DataGrid';
const columns = [
    {
        field: 'name', headerName: 'Name', width: 230,
        renderCell: (params) => (
            <Link style={{textDecoration: 'none'}} component={RouterLink} to={'/gas/template/' + params.row.id}>
                {params.row.emailTemplate.templateName}
            </Link>
        )
    },
    {
        field: 'language', headerName: 'Language', width: 200, renderCell: (params) => (
            <>{params.row.language.name}</>
        )
    }
]

const GasEmailTemplate = () => {
        const [list, setList] = useState([]);
        useEffect(() => {
            EmailContentService.getAll()
                .then((response) => {
                    setList(response.data);
                });
        }, []);

        return (
            <Container>
                <header>
                    <h1>Email Templates</h1>
                </header>
            
                    <Grid container spacing={5}>
                        {/*<Grid item xs={12}>*/}
                        {/*    <Link component={RouterLink} to='/gas/country/new'>Create New</Link>*/}
                        {/*</Grid>*/}
                        <Grid item xs={12}>
                        <CustomDataGrid 
                                rows={list}
                                columns={columns}
                                rowHeight={35}
                                components={false}/>
                      
                        </Grid>
                    </Grid>
                   
            </Container>
        );
    }
;

export default GasEmailTemplate;
